import { safeSessionStorage } from "@/lib/storage/safe-storage";
import {
  PUBLIC_TOOLS,
  type PublicTool,
  type ToolUsageStep,
} from "@shared/analytics/tools";
import { narrowToOneOf } from "@shared/validation/is-one-of";
import { track } from "./tracker";

export interface ToolUsedProperties {
  tool: PublicTool;
  tool_step: ToolUsageStep;
  productTypeSlug?: string;
}

export interface ToolEventMap {
  "tool.used": ToolUsedProperties;
}

const SOURCE_TOOL_KEY = "__repackify_source_tool";

export function trackToolUsed(properties: ToolUsedProperties): void {
  track("tool.used", properties);
  safeSessionStorage().setItem(SOURCE_TOOL_KEY, properties.tool);
}

export function readSourceTool(): PublicTool | undefined {
  return narrowToOneOf(PUBLIC_TOOLS, safeSessionStorage().getItem(SOURCE_TOOL_KEY));
}
